import { useQuery } from "react-query";
import { getLeasedEquipmentByRecordNumber } from "../../../../actions/CarrierAgreementMgmt/LeasedEquipment";

export const useGetLeasedEquipmentByRecordNumber = (recordNumber) => {
  return useQuery(
    ["GetLeasedEquipmentByRecordNumber", recordNumber],
    () => getLeasedEquipmentByRecordNumber(recordNumber),
    { refetchOnWindowFocus: false }
  );
};
